import { helper } from '@ember/component/helper';
import { get } from '@ember/object';

function hasValidationError([changeset, property]) {
  return get(changeset, `error.${property}.validation`) != null;
}

export default helper(hasValidationError);
